import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';

const MoneySchool = () => {
  const moneySchoolUrl = 'https://copy-of-money-school-383379020587.us-west1.run.app/';

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#1A2942] to-[#1E3A5F] px-6 py-4 border-b border-[#2D5A8F] flex items-center">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-lg bg-[#FFD700]/20 flex items-center justify-center">
            <FaGraduationCap className="text-[#FFD700] text-xl" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-white">Money School</h1>
            <p className="text-gray-400 text-sm">Learn Personal Finance & Money Management</p>
          </div>
        </div>
      </div>

      {/* Embedded Money School */}
      <div className="flex-1 relative">
        <iframe
          src={moneySchoolUrl}
          title="Money School"
          className="w-full h-full border-0"
          style={{ minHeight: 'calc(100vh - 200px)' }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default MoneySchool;
